import request from "@/utils/request";
import URL from "@/api/baseUrl";

const basePath = `${URL.vip}/vip-bill-management`;

export default class BillManagement {
  static list(params = {}) {
    return request.get(`${basePath}/list`, params);
  }

  static getInfo(params = {}) {
    return request.get(`${basePath}/getInfo`, params);
  }

  static templateExportBill(data = {}) {
    return request.post(`${basePath}/templateExportBill`, data, {
      responseType: "blob",
    });
  }
}
